console.clear()

/**
 * IMPORTS
 */
import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollSmoother } from 'gsap/ScrollSmoother'
gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

/**
 * VARIABLES
 */
const home = document.querySelector('.home')
const rspv = document.querySelector('.reponse')
const dresscode = document.querySelector('.dresscode')
const burgerMenu = document.querySelector('.header__burgerMenu')
const navMenu = document.querySelector('.header__nav')
const isRetina = window.devicePixelRatio > 1


/**
 * SCROLL SMOOTHER
 */
const smoother = ScrollSmoother.create({
  wrapper: '#smooth-wrapper',
  content: '#smooth-content',
  smooth: 1.5, 
  effects: true 
})

/**
 * GET HEIGHT 
 * */
var height = window.innerHeight
document.documentElement.style.setProperty('--screen-height', height + 'px')
window.addEventListener('resize', function () {
  var height = window.innerHeight
  document.documentElement.style.setProperty('--screen-height', height + 'px')
})

/**
* MUSIC BUTTON
*/
const musicButton = document.querySelector('.btn__music');
const bars = document.querySelector('.bars');
const audio = document.getElementById('backgroundMusic');

let isPlaying = localStorage.getItem('musicPlaying') === 'true';
const savedTime = parseFloat(localStorage.getItem('musicTime')) || 0;

if (isPlaying) {
  audio.currentTime = savedTime;
  audio.play().catch(() => {
    isPlaying = false;
    localStorage.setItem('musicPlaying', 'false');
  });
  bars.classList.add('playing');
} else {
  audio.currentTime = savedTime;
}

function toggleMusic() {
  if (isPlaying) {
    audio.pause();
    bars.classList.remove('playing');
    localStorage.setItem('musicPlaying', 'false');
  } else {
    audio.play();
    bars.classList.add('playing');
    localStorage.setItem('musicPlaying', 'true');
  }
    
  isPlaying = !isPlaying;
}

musicButton.addEventListener('click', toggleMusic);

document.addEventListener('keydown', (event) => {
  if (event.code === 'MediaPlayPause') {
    event.preventDefault();
    toggleMusic();
  }
});

audio.addEventListener('pause', () => {
  bars.classList.remove('playing');
  isPlaying = false;
  localStorage.setItem('musicPlaying', 'false');
});

audio.addEventListener('play', () => {
  bars.classList.add('playing');
  isPlaying = true;
  localStorage.setItem('musicPlaying', 'true');
});

audio.addEventListener('timeupdate', () => {
  localStorage.setItem('musicTime', audio.currentTime);
});

window.addEventListener('beforeunload', () => {
  localStorage.setItem('musicTime', audio.currentTime);
});

/**
 * PAGES TRANSITION
 */
const links = document.querySelectorAll('a.header__navLink, a.buttonTransition');
links.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    const href = link.getAttribute('href');
    if (href) {
      const transition = document.querySelector('.transition');
      transition.classList.add('transition--show');
      transition.addEventListener('transitionend', () => {
        localStorage.setItem('isTransitioning', 'true');
        window.location.href = href;
      }, { once: true });
    }
  });
});

const transition = document.querySelector('.transition');
const loader = document.querySelector('.loader');
const isTransitioning = localStorage.getItem('isTransitioning') === 'true';

if (isTransitioning) {
  localStorage.removeItem('isTransitioning');
  if (loader) {
    loader.style.display = 'none';
  }
  transition.style.transition = 'none';
  transition.classList.add('transition--show');
  transition.offsetHeight; 
  transition.style.transition = '';
  setTimeout(() => {
    transition.classList.add('transition--hidden');
  }, 10);
  transition.addEventListener('transitionend', () => {
    transition.classList.remove('transition--show', 'transition--hidden');
  }, { once: true });
} else {
  window.addEventListener('load', () => {
    if (loader) {
      loader.classList.add('loader--hidden');
    }
  });
}


/**
 * BURGER MENU
 */
let isOpen = false;

burgerMenu.addEventListener('click', () => {
    navMenu.classList.toggle('header__nav--show')

    if (!isOpen) {
        burgerMenu.style.backgroundImage = "url('/assets/icons/cross.svg')" ;
        isOpen = true;
    } else {
        burgerMenu.style.backgroundImage = "url('/assets/icons/menuBurger.svg')";
            isOpen = false;
     }
})



/**
 * HOME CODE
 */
if (home) {
  /**
   * LOADER ANIMATION
   */
  const loaderH = document.querySelector('.loader');
  const progressBar = document.querySelector('.loader__barInner');
  const hasVisited = sessionStorage.getItem('hasVisitedHome');

  if (hasVisited) {
    loaderH.classList.add('loader--hidden');
    loaderH.style.display = 'none';
  } else {
    sessionStorage.setItem('hasVisitedHome', 'true');
        
    const startTime = Date.now(); 
    const minDuration = 2000;     
    let progress = 0;

    // Progression bar
    const interval = setInterval(() => {
      progress += Math.random() * 8 + 2;
      if (progress > 90) progress = 90;
      progressBar.style.width = progress + '%';
    }, 100);

    // Loading's end
    const finishLoading = () => {
      clearInterval(interval);
      progressBar.style.width = '100%';

      setTimeout(() => {
        loaderH.classList.add('loader--hidden');
      }, 400);
    };

    // Attente 2s minimum
    window.addEventListener('load', () => {
      clearInterval(interval); 
      const elapsedTime = Date.now() - startTime;

      if (elapsedTime >= minDuration) {
        finishLoading();
      } else {
        const remainingTime = minDuration - elapsedTime;
        setTimeout(() => {
          finishLoading();
        }, remainingTime);
      }
    });
  }

  /**
   * BACKGROUND WATER EFFECT
   */
  const canvas = document.querySelector('.firstSection__canvas')
  const scene = new THREE.Scene()
  const camera = new THREE.PerspectiveCamera(
    45,
    window.innerWidth / window.innerHeight,
    0.1,
    100
  )
  camera.position.z = 2

  const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
  })
  renderer.setSize(window.innerWidth, window.innerHeight)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
  renderer.outputEncoding = THREE.sRGBEncoding
  renderer.toneMapping = THREE.NoToneMapping

  const planeWidth = 3840
  const planeHeight = 2152
  const planeRatio = planeWidth / planeHeight

  const loader = new THREE.TextureLoader()
  const textureUrl = isRetina ? '/assets/images/atlantide@2x.webp' : '/assets/images/atlantide.webp'
  const texture = loader.load(textureUrl, () => {
    texture.minFilter = THREE.LinearFilter
    texture.magFilter = THREE.LinearFilter
    texture.anisotropy = renderer.capabilities.getMaxAnisotropy()
    renderer.render(scene, camera)
  })
  texture.encoding = THREE.sRGBEncoding

  const uniforms = {
    uTexture: { value: texture },
    uMouse: { value: new THREE.Vector2(-10, -10) },
    uTime: { value: 0 },
  }

  const material = new THREE.ShaderMaterial({
    uniforms,
    vertexShader: `
      varying vec2 vUv;
      void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
      `,
    fragmentShader: `
      precision mediump float;
      uniform sampler2D uTexture;
      uniform vec2 uMouse;
      uniform float uTime;
      varying vec2 vUv;

      void main() {
        vec2 wave = vec2(
          sin(vUv.y * 2.0 + uTime * .2) * 0.02,
          cos(vUv.x * 6.0 + uTime * .1) * 0.02
        );

        float dist = distance(vUv, uMouse);
        float strength = 0.03 / (dist + 0.03);
        vec2 direction = normalize(vUv - uMouse);

        vec2 distortedUv = vUv + 
        wave + 
        direction * strength * 0.02;

        vec4 color = texture2D(uTexture, distortedUv);
        gl_FragColor = color;
      }
    `,
  })

  const geometry = new THREE.PlaneGeometry(planeWidth, planeHeight)
  const plane = new THREE.Mesh(geometry, material)
  scene.add(plane)

  const overscale = 1.08

  const updatePlaneScale = () => {
    const screenRatio = window.innerWidth / window.innerHeight
    const distance = camera.position.z
    const vFOV = camera.fov * (Math.PI / 180)
    const visibleHeight = 2 * Math.tan(vFOV / 2) * distance
    const visibleWidth = visibleHeight * screenRatio

    let scaleX, scaleY

    if (screenRatio > planeRatio) {
        scaleX = visibleWidth
        scaleY = visibleWidth / planeRatio
    } else {
        scaleY = visibleHeight
        scaleX = visibleHeight * planeRatio
    }

    // 🎯 marge anti-déformation
    scaleX *= overscale
    scaleY *= overscale

    plane.scale.set(scaleX / planeWidth, scaleY / planeHeight, 1)
  }

  updatePlaneScale()

  window.addEventListener('mousemove', (event) => {
    uniforms.uMouse.value.x = event.clientX / window.innerWidth
    uniforms.uMouse.value.y = 1.0 - event.clientY / window.innerHeight
  })

  window.addEventListener('resize', () => {
    camera.aspect = window.innerWidth / window.innerHeight
    camera.updateProjectionMatrix()
    renderer.setSize(window.innerWidth, window.innerHeight)
    updatePlaneScale()
  })

  const tic = (time) => {
    uniforms.uTime.value = time * 0.001
    renderer.render(scene, camera)
    requestAnimationFrame(tic)
  }
  tic()

  /**
   * FISHES SECTION
   */
  class CanvasImageManager {
    constructor(canvasSelector) {
      this.canvas = document.querySelector(canvasSelector);
      this.ctx = this.canvas.getContext('2d');
      this.images = [];
      this.loadedImages = [];
      this.scrollY = 0;
      this.canvasOffsetTop = 0;
      
      this.imagePaths = [
        isRetina ? '/assets/images/fishes/1@2x.webp' : '/assets/images/fishes/1.webp',
        isRetina ? '/assets/images/fishes/2@2x.webp' : '/assets/images/fishes/2.webp',
        isRetina ? '/assets/images/fishes/3@2x.webp' : '/assets/images/fishes/3.webp',
        isRetina ? '/assets/images/fishes/4@2x.webp' : '/assets/images/fishes/4.webp',
        isRetina ? '/assets/images/fishes/5@2x.webp' : '/assets/images/fishes/5.webp',
        isRetina ? '/assets/images/fishes/6@2x.webp' : '/assets/images/fishes/6.webp',
        isRetina ? '/assets/images/fishes/7@2x.webp' : '/assets/images/fishes/7.webp',
        isRetina ? '/assets/images/fishes/8@2x.webp' : '/assets/images/fishes/8.webp',
        isRetina ? '/assets/images/fishes/9@2x.webp' : '/assets/images/fishes/9.webp',
        isRetina ? '/assets/images/fishes/10@2x.webp' : '/assets/images/fishes/10.webp',
        isRetina ? '/assets/images/fishes/11@2x.webp' : '/assets/images/fishes/11.webp',
        isRetina ? '/assets/images/fishes/12@2x.webp' : '/assets/images/fishes/12.webp',
        isRetina ? '/assets/images/fishes/13@2x.webp' : '/assets/images/fishes/13.webp',
        isRetina ? '/assets/images/fishes/14@2x.webp' : '/assets/images/fishes/14.webp',
        isRetina ? '/assets/images/fishes/15@2x.webp' : '/assets/images/fishes/15.webp',
        isRetina ? '/assets/images/fishes/16@2x.webp' : '/assets/images/fishes/16.webp',
        isRetina ? '/assets/images/fishes/17@2x.webp' : '/assets/images/fishes/17.webp',
        isRetina ? '/assets/images/fishes/18@2x.webp' : '/assets/images/fishes/18.webp'
      ];
      
      this.init();
    }
    
    init() {
      this.setupCanvas();
      this.loadImages();
      this.setupScrollListener();
      window.addEventListener('resize', () => this.handleResize());
    }
    
    setupCanvas() {
      this.canvas.width = this.canvas.offsetWidth;
      this.canvas.height = this.canvas.offsetHeight;
      this.updateCanvasOffset();
    }
    
    updateCanvasOffset() {
      const rect = this.canvas.getBoundingClientRect();
      this.canvasOffsetTop = rect.top + window.scrollY;
    }
    
    setupScrollListener() {
      window.addEventListener('scroll', () => {
        this.scrollY = window.scrollY;
        this.render();
      });
    }
    
    loadImages() {
      let loadedCount = 0;
      
      this.imagePaths.forEach((path, index) => {
        const img = new Image();
        img.onload = () => {
          loadedCount++;
          if (loadedCount === this.imagePaths.length) {
            this.render();
          }
        };
        img.src = path;
        this.loadedImages.push(img);
      });
    }
    
    // Méthode pour ajouter une image avec position, largeur et vitesse parallax
    addImage(imageIndex, x, y, width, xMobile = null, yMobile = null, widthMobile = null, parallaxSpeed = 0.5) {
      const img = this.loadedImages[imageIndex];
      if (!img) return;
      
      this.images.push({
        img: img,
        x: x, 
        y: y,
        width: width,
        xMobile: xMobile, 
        yMobile: yMobile, 
        widthMobile: widthMobile, 
        imageIndex: imageIndex,
        parallaxSpeed: parallaxSpeed // Vitesse de 0 (statique) à 1 (rapide)
      });
    }
    
    // Convertir les valeurs % en pixels
    convertToPixels(value, dimension) {
      if (typeof value === 'string' && value.includes('%')) {
        const percentage = parseFloat(value) / 100;
        return dimension * percentage;
      }
      return value;
    }
    
    // Calculer l'offset parallax pour une image
    calculateParallaxOffset(parallaxSpeed) {
      // Calculer la position relative du scroll par rapport au canvas
      const relativeScroll = this.scrollY - this.canvasOffsetTop + window.innerHeight;
      
      // Appliquer la vitesse parallax
      return relativeScroll * parallaxSpeed * 0.3; // 0.3 est un facteur d'atténuation
    }
    
    // Méthode pour dessiner toutes les images
    render() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      
      const isMobile = window.innerWidth <= 760;
      
      // Dessiner chaque image avec effet parallax
      this.images.forEach(imageData => {
        const img = imageData.img;
        
        const xValue = isMobile && imageData.xMobile !== null ? imageData.xMobile : imageData.x;
        const yValue = isMobile && imageData.yMobile !== null ? imageData.yMobile : imageData.y;
        const widthValue = isMobile && imageData.widthMobile !== null ? imageData.widthMobile : imageData.width;
        
        const x = this.convertToPixels(xValue, this.canvas.width);
        let y = this.convertToPixels(yValue, this.canvas.height);
        const width = this.convertToPixels(widthValue, this.canvas.width);
        
        // Appliquer l'effet parallax sur Y
        const parallaxOffset = this.calculateParallaxOffset(imageData.parallaxSpeed);
        y += parallaxOffset;
        
        const aspectRatio = img.height / img.width;
        const height = width * aspectRatio;
        
        this.ctx.drawImage(img, x, y, width, height);
      });
    }
    
    handleResize() {
      this.setupCanvas();
      this.render();
    }
  }

  // Initialisation
  const canvasManager = new CanvasImageManager('.thirdSection__canvas');

  setTimeout(() => {
    // Syntaxe : addImage(index, xDesktop, yDesktop, widthDesktop, xMobile, yMobile, widthMobile, parallaxSpeed)
    canvasManager.addImage(0, '-2%', '10%', '20%', '10%', '5%', '50%', 0.3); //8 sardines - très lent
    canvasManager.addImage(1, '20%', '25%', '10%', '5%', '90%', '20%', 0.5); // 2 sardines - rapide
    canvasManager.addImage(2, '50%', '70%', '20%', '45%', '40%', '25%', 0.2); //2 sardines - moyen
    canvasManager.addImage(3, '80%', '50%', '20%', '70%', '60%', '50%', 0.5); // 2 sardines - très rapide
    canvasManager.addImage(4, '30%', '15%', '12%', '40%', '10%', '30%', 0.3); //3 sardines - lent
    canvasManager.addImage(5, '40%', '60%', '15%', '60%', '80%', '60%', 0.5); // 4 fishes alone - moyen
    canvasManager.addImage(6, '25%', '5%', '10%', '20%', '35%', '20%', 0.5); //fish alone - très rapide
    canvasManager.addImage(7, '0%', '40%', '10%', '60%', '0%', '25%', 0.3); //fish alone - très lent
    canvasManager.addImage(8, '90%', '80%', '10%', '20%', '50%', '25%', 0.2); //fish alone - rapide
    canvasManager.addImage(9, '5%', '50%', '10%', '30%', '95%', '20%', 0.4); //fish alone - moyen
    canvasManager.addImage(10, '35%', '90%', '15%', '60%', '55%', '30%', 0.5); //fish alone - très rapide
    canvasManager.addImage(11, '80%', '40%', '10%', '15%', '83%', '20%', 0.2); //fish alone - lent
    canvasManager.addImage(12, '90%', '0%', '12%', '90%', '45%', '25%', 0.5); //fish alone - moyen
    canvasManager.addImage(13, '60%', '10%', '20%', '-10%', '25%', '30%', 0.5); //4 fishes alone - très rapide
    canvasManager.addImage(14, '60%', '50%', '15%', '40%', '70%', '45%', 0.3); //6 sardines - très lent
    canvasManager.addImage(15, '-5%', '60%', '35%', '60%', '20%', '50%', 0.2); //calamars - rapide
    canvasManager.addImage(16, '25%', '30%', '35%', '-20%', '55%', '70%', 0.4); //calamars - moyen
    canvasManager.addImage(17, '85%', '20%', '20%', '0%', '45%', '20%', 0.5); // 2 sardines - très rapide
    
    // Rendre le canvas
    canvasManager.render();
  }, 500);

  /**
   * COMPTEUR
   */
  function getCountdownValues() {
      const now = new Date()
      const targetDate = new Date('2026-05-02T20:00:00Z')
      const diff = targetDate - now

      if (diff <= 0) return { days: 0, hours: 0, minutes: 0 }

      return {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor(diff / (1000 * 60 * 60)) % 24,
        minutes: Math.floor(diff / (1000 * 60)) % 60
      }
  }
  function getRandomRollingDigits(finalValue, progress) {
      const strFinal = String(finalValue).padStart(2, '0')
      let result = ''

      for (let i = 0; i < 2; i++) {
        const charFinal = strFinal[i]
        const threshold = 0.8 + i * 0.1

        if (progress < threshold) {
          const randomDigit = 1 + Math.floor(Math.random() * 9)
          result += randomDigit
        } else {
          result += charFinal
        }
      }
      return result
  }
  function animateRollingNumberRandom(element, finalValue, progress) {
      if (!element) return
      const textNode = [...element.childNodes].find(n => n.nodeType === 3)
      if (!textNode) return

      const displayStr = getRandomRollingDigits(finalValue, progress)
      textNode.textContent = displayStr
  }

  const { days, hours, minutes } = getCountdownValues()

  ScrollTrigger.create({
    trigger: ".fourthSection",
    start: "-10% center",
    end: "30% center",
    scrub: 1,
    onUpdate: self => {
      const daysEl = document.querySelector('#days.fourthSection__compteurEl')
      const hoursEl = document.querySelector('#hours.fourthSection__compteurEl')
      const minutesEl = document.querySelector('#minutes.fourthSection__compteurEl')

      if (self.progress === 1) {
        daysEl.textContent = String(days).padStart(2, '0')
        daysEl.insertAdjacentHTML('beforeend', '<span class="fourthSection__compteurEl--temps">jours</span>')

        hoursEl.textContent = String(hours).padStart(2, '0')
        hoursEl.insertAdjacentHTML('beforeend', '<span class="fourthSection__compteurEl--temps">heures</span>')

        minutesEl.textContent = String(minutes).padStart(2, '0')
        minutesEl.insertAdjacentHTML('beforeend', '<span class="fourthSection__compteurEl--temps">minutes</span>')
      } else {
        animateRollingNumberRandom(daysEl, days, self.progress)
        animateRollingNumberRandom(hoursEl, hours, self.progress)
        animateRollingNumberRandom(minutesEl, minutes, self.progress)
      }
    }
  })
}

/**
 * FORM CODE
 */
else if (rspv){
  // ================================
  // SCROLL PROGRESS
  // ================================
  const formAll = document.querySelector('.formAll');
  const fill = document.querySelector('.formAll__scrollProgress .formAll__fill');

  if (formAll && fill) {
    formAll.addEventListener('scroll', () => {
      const scrollTop = formAll.scrollTop;
      const scrollHeight = formAll.scrollHeight - formAll.clientHeight;
      const scrollPercent = (scrollTop / scrollHeight) * 100;
      fill.style.height = scrollPercent + '%';
    });
  }

  // ================================
  // VALIDATION DES CHAMPS
  // ================================
  function validateForm() {
    let isValid = true;
    
    // Supprime tous les anciens messages d'erreur
    document.querySelectorAll('.field-error').forEach(el => el.remove());
    document.querySelectorAll('.error').forEach(el => el.classList.remove('error'));
    
    // Champs obligatoires
    const firstName = document.querySelector('[name="firstName"]');
    const lastName = document.querySelector('[name="lastName"]');
    const message = document.querySelector('[name="message"]');
    
    if (!firstName || !firstName.value.trim()) {
      showFieldError(firstName, "Champ obligatoire");
      isValid = false;
    }
    
    if (!lastName || !lastName.value.trim()) {
      showFieldError(lastName, "Champ obligatoire");
      isValid = false;
    }
    
    if (!message || !message.value.trim()) {
      showFieldError(message, "Champ obligatoire");
      isValid = false;
    }
    
    return isValid;
  }


  function showFieldError(field, message) {
    field.classList.add('error');
    
    const errorMsg = document.createElement('div');
    errorMsg.className = 'field-error';
    errorMsg.style.cssText = 'color: #FF5D5D; font-size: 0.9em; margin-top: 5px;';
    errorMsg.textContent = message;
    
    field.parentElement.appendChild(errorMsg);
  }

  // ================================
  // SUBMIT FORM
  // ================================
  const scriptURL = "https://script.google.com/macros/s/AKfycbxhFcbA0vZ1ku9W-znvLxZ4eoAooHGzLzFQLQ4cBKbwuJo_VjPOZyll3QDJWsTTfPhiOA/exec";
  const form = document.querySelector("form.form");
  const submitButton = form.querySelector("button[type='submit']");

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    // VALIDATION AVANT ENVOI
    if (!validateForm()) {
      return; // Stop l'envoi si erreurs
    }

    const originalText = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.textContent = "Envoi en cours…";

    const formData = new FormData(form);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      params.append(key, value);
    }

    try {
      const response = await fetch(scriptURL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params
      });

      let result;
      try {
        result = await response.json();
      } catch (jsonErr) {
        throw new Error("Impossible de lire la réponse du serveur.");
      }

      if (result.result === "error") {
        showError(result.message || "Erreur serveur inconnue.");
      } else {
        showConfirmation(result.action);
      }

    } catch (err) {
      showError(err.message);
      console.error(err);
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = originalText;
    }
  });

  // ================================
  // AFFICHAGE D'UNE ERREUR
  // ================================
  function showError(message) {
    formAll.style.display = "none";

    const confHTML = `
      <div class="conf">
        <h1 class="conf__title">Une erreur est survenue</h1>
        <p class="conf__p">${message}</p>
        <a class="conf__link btn" href="remerciements.html">Réessayer</a>
      </div>
    `;

    formAll.parentElement.insertAdjacentHTML("beforeend", confHTML);
  }

  // ================================
  // CONFIRMATION
  // ================================
  function showConfirmation(action) {
    formAll.style.display = "none";

    const confHTML = `
      <div class="conf">
        <h1 class="conf__title">Merci beaucoup d'avoir partagé ce moment inoubliable avec nous!</h1>
        <a class="conf__link btn buttonTransition" href="index.html">Accueil</a>
      </div>
    `;

    formAll.parentElement.insertAdjacentHTML("beforeend", confHTML);
  }
}

/**
 * DRESSCODE CODE
 */
else if (dresscode) {
  const container = document.querySelector('.inspi')
  const btnLeft = document.querySelector('.inspi__btn--left')
  const btnRight = document.querySelector('.inspi__btn--right')
  const scrollStep = 350
  const els = document.querySelectorAll('.inspi__el')
  const maxShift = 15

  let targetScrollLeft = container.scrollLeft
  let animationFrameId = null

  function updateButtons() {
    const tolerance = 2
    if (targetScrollLeft <= tolerance) {
      btnLeft.classList.add('inspi__btn--disabled')
    } else {
      btnLeft.classList.remove('inspi__btn--disabled')
    }
    if (targetScrollLeft + container.clientWidth >= container.scrollWidth - tolerance) {
      btnRight.classList.add('inspi__btn--disabled')
    } else {
      btnRight.classList.remove('inspi__btn--disabled')
    }
  }

  let ticking = false
  container.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateButtons()
        ticking = false
      })
      ticking = true
    }
  })

  function smoothScrollToTarget() {
    const currentScroll = container.scrollLeft
    const distance = targetScrollLeft - currentScroll
    const step = distance * 0.05

    if (Math.abs(distance) > 0.5) {
      container.scrollLeft = currentScroll + step
      animationFrameId = requestAnimationFrame(smoothScrollToTarget)
    } else {
      container.scrollLeft = targetScrollLeft
      cancelAnimationFrame(animationFrameId)
      animationFrameId = null
      updateButtons()
      updateProgressBars()
      updateParallax()
    }
  }

  container.addEventListener('wheel', (e) => {
    e.preventDefault()
    targetScrollLeft += e.deltaY + e.deltaX
    targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, container.scrollWidth - container.clientWidth))

    if (!animationFrameId) {
      smoothScrollToTarget()
    }
    
  }, { passive: false })

  let touchStartX = 0
  container.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX
  }, { passive: true })

  container.addEventListener('touchmove', (e) => {
    const touchX = e.touches[0].clientX
    const deltaX = touchStartX - touchX

    if (Math.abs(deltaX) > 2) {
      targetScrollLeft += deltaX
      targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, container.scrollWidth - container.clientWidth))

      if (!animationFrameId) {
        smoothScrollToTarget()
      }
      touchStartX = touchX
      e.preventDefault()
    }
  }, { passive: false })

  btnLeft.addEventListener('click', () => {
    if (btnLeft.classList.contains('inspi__btn--disabled')) return
    targetScrollLeft = Math.max(0, targetScrollLeft - scrollStep)
    if (!animationFrameId) smoothScrollToTarget()
  })

  btnRight.addEventListener('click', () => {
    if (btnRight.classList.contains('inspi__btn--disabled')) return
    targetScrollLeft = Math.min(container.scrollWidth - container.clientWidth, targetScrollLeft + scrollStep)
    if (!animationFrameId) smoothScrollToTarget()
  })

  updateButtons()
}